/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentOrderTrackingViewModel } from "../types/IndividualPaymentOrderTrackingViewModel.ts";

export const individualPaymentOrderTrackingViewModelSchema = z.object({
  dateLog: z.optional(z.string().datetime()),
  type: z.optional(z.number().int()),
  typeName: z.string().nullish(),
  userName: z.string().nullish(),
  entityId: z.optional(z.number().int()),
  orderId: z.string().nullish(),
  message: z.string().nullish(),
  payload: z.string().nullish(),
  result: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentOrderTrackingViewModel>;
